import axios from 'axios';
import resetMessage from '@/utils/resetMessage';

// const Message = new DonMessage();
// var CancelToken = axios.CancelToken;
// var source = CancelToken.source();
// create an axios instance
const service = axios.create({
  baseURL: '/lice-cli', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 0, // request timeout
  validateStatus(status) {
    switch (status) {
      case 400:
        resetMessage.error('请求出错');
        break;
      case 403:
        resetMessage.warning({
          message: '拒绝访问',
        });
        break;
      case 404:
        resetMessage.error({
          message: '请求错误,未找到该资源',
        });
        break;
      case 500:
        resetMessage.error({
          message: '服务端错误',
        });
        break;
    }
    return status >= 200 && status < 300;
  },
});

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // if the custom code is not 200, it is judged as an error.
    if (response.config.responseType === 'arraybuffer') {
      return response;
    }
    const res = response.data;
    if (res.status === 200) {
      return res;
    } else {
      resetMessage.error(res.message);
      return res;
    }
  },
  (error) => {
    if (error.response) {
      resetMessage({
        message: error.response.data.message,
        type: 'error',
        duration: 3 * 1000,
      });
    } else {
      resetMessage({
        message: error.message,
        type: 'error',
        duration: 3 * 1000,
      });
    }
    return Promise.reject(error);
  },
);

export default service;
